// Single font stack app-wide (weights 400, 500, 700 only)
const FONT_STACK = `"Roboto", system-ui, -apple-system, "Segoe UI", "Helvetica Neue", "Noto Sans", "Liberation Sans", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"`;

export const BODY_TYPEFACE = 'Roboto';
export const HEADING_TYPEFACE = 'Roboto';
export const MONO_TYPEFACE = FONT_STACK;

const typography = {
  fonts: {
    heading: FONT_STACK,
    body: FONT_STACK,
    mono: FONT_STACK,
  },
  fontWeights: {
    normal: 400,
    medium: 500,
    bold: 700,
  },
  textStyles: {
    h2: {
      fontSize: [ '32px' ],
      fontWeight: '500',
      lineHeight: '40px',
      fontFamily: 'heading',
    },
    h3: {
      fontSize: '24px',
      fontWeight: '500',
      lineHeight: '32px',
      fontFamily: 'heading',
    },
    h4: {
      fontSize: 'md',
      fontWeight: '500',
      lineHeight: '24px',
      fontFamily: 'heading',
    },
  },
};

export default typography;
